import { useState } from 'react';
import styled from 'styled-components';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeExternalLinks from 'rehype-external-links';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp } from '@fortawesome/free-solid-svg-icons';

const Info = ({ label, info }) => {
  const [open, setOpen] = useState(false);

  return (
    <Container>
      <LabelContainer type="button" onClick={() => setOpen(!open)}>
        <ChevronContainer>
          <Chevron collapsed={!open} icon={faChevronUp} />
        </ChevronContainer>
        <Label>{label}</Label>
      </LabelContainer>
      {open && (
        <Content>
          <ReactMarkdown
            remarkPlugins={[remarkGfm]}
            rehypePlugins={[[rehypeExternalLinks, { target: '_blank' }]]}
          >
            {info}
          </ReactMarkdown>
        </Content>
      )}
    </Container>
  );
};

const chevronWidth = 32;

const Container = styled.div`
  color: var(--primaryColor);
  font-size: 16px;
`;

const LabelContainer = styled.button`
  margin-bottom: 12px;
  color: var(--primaryColor);
`;

const ChevronContainer = styled.div`
  display: inline-block;
  width: ${chevronWidth}px;
  text-align: left;
`;
const Chevron = styled(FontAwesomeIcon)`
  transform: ${props => (props.collapsed ? 'rotate(-180deg)' : 'none')};
  transition: transform 0.1s;
`;

const Label = styled.label`
  cursor: pointer;
`;

const Content = styled.div`
  padding-left: ${chevronWidth}px;

  a {
    color: var(--green);
    text-decoration: underline;

    &:hover {
      color: var(--green);
    }

    &::after {
      font-family: 'Font Awesome 5 Free';
      content: '\f35d';
      font-weight: 900;
      font-size: 14px;
      margin-left: 4px;
      margin-right: 3px;
      text-decoration: none;
    }
  }
`;

export default Info;
